const SOURCE_LABELS = {
  AI: 'AI',
  MANUAL: 'Manual',
  BOT: 'Bot',
  COPY: 'Copy',
  BACKTEST: 'Backtest',
  PLATFORM_ONLY: 'Platform only',
  PLATFORM_SYNCED_WITH_DB: 'Synced',
};

export function formatTradeSource(value) {
  if (value == null || value === '') return '-';

  const raw = String(value).trim();
  const key = raw.replace(/[\s-]+/g, '_').toUpperCase();
  if (SOURCE_LABELS[key]) return SOURCE_LABELS[key];

  return raw
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export function resolveTradeSourceLabel(item) {
  return formatTradeSource(
    item?.source_display
      ?? item?.source
      ?? item?.trade_source
      ?? item?.order_source
      ?? item?.sync_status
  );
}
